import { CustomizationOptionDto } from "../../../../../../api/src/creative-unit-package/models/customization/customization-option.dto";

export const LOADING_OPTION: CustomizationOptionDto = {
	id: '1',
	label: $localize`:Loading Customization Option Label@@loadingCustomizationOptionLabel:Loading options...`,
	value: undefined
};

export const EMPTY_OPTION: CustomizationOptionDto = {
	id: '1',
	label: $localize`:Empty Customization Option Label@@emptyCustomizationOptionLabel:No options found`,
	value: undefined
}
